// DS1.5
import React from 'react';
import { Url } from '@wix/da-url';
const Logo = ({ className, style, markColor = 'green', markColorClassname, textColor = 'black', textColorClassname, size = 'medium', withText = true })=>{
    return /*#__PURE__*/ React.createElement("div", {
        style: style
    }, !withText && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("img", {
        src: Url.staticCDNLink('eclipse/promos/logo-dark-dabirthday_24.svg'),
        alt: 'Logo'
    })), withText && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 132,
        height: 54,
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#06070E",
        d: "M0 0h132v54H0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#a)",
        d: "M0 0h132v54H0z"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#b)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "h",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162zM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#c)",
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#d)",
        fillRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#e)",
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#f)",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#g)",
        strokeLinejoin: "round",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd",
        mask: "url(#h)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#i)",
        strokeLinejoin: "round",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd",
        mask: "url(#h)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#j)",
        strokeLinejoin: "round",
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        mask: "url(#h)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#k)",
        strokeLinejoin: "round",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        mask: "url(#h)"
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'screen'
        }
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "q",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162zM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#l)",
        fillOpacity: 0.4,
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#m)",
        fillOpacity: 0.4,
        fillRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#n)",
        fillOpacity: 0.4,
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#o)",
        fillOpacity: 0.4,
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#p)",
        strokeLinejoin: "round",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd",
        mask: "url(#q)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#r)",
        strokeLinejoin: "round",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd",
        mask: "url(#q)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#s)",
        strokeLinejoin: "round",
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        mask: "url(#q)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#t)",
        strokeLinejoin: "round",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        mask: "url(#q)"
    })), /*#__PURE__*/ React.createElement("g", {
        style: {
            mixBlendMode: 'overlay'
        }
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "z",
        fill: "#fff"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162zM91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#u)",
        fillRule: "evenodd",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182M45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#v)",
        fillRule: "evenodd",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#w)",
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#x)",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#y)",
        strokeLinejoin: "round",
        d: "M51.042 14.278c-.078.152-.427.811-.774 1.463a30 30 0 0 0-.631 1.221c0 .02.284.035.631.035 1.11 0 1.735.198 2.314.735.633.586.937 1.602.78 2.602-.098.623-.307 1.078-.678 1.47-.566.6-1.257.834-2.455.836h-.72v-2.675c0-1.687-.023-2.654-.061-2.616-.034.033-.812 1.479-1.73 3.212l-1.668 3.153v1.914l3.058-.023c3.51-.026 3.595-.037 4.787-.615.752-.364 1.276-.766 1.74-1.335 1.398-1.713 1.637-4.684.55-6.817-.797-1.562-2.498-2.613-4.522-2.795L51.185 14zM57.77 25.62h9.03v-3.043h-5.508v-1.269h5.059v-2.98h-5.064l.037-1.237 5.475-.033v-3.043h-9.03V25.62Zm9.94-11.493c.016.06.646 2.671 1.4 5.802l1.371 5.69 3.785.001 3.039-5.745a1501 1501 0 0 0 3.06-5.803c.012-.032-.757-.056-1.798-.056H76.75l-1.845 3.49c-1.014 1.92-1.856 3.479-1.872 3.464-.023-.023-1.027-4.128-1.558-6.368l-.139-.586h-1.827c-1.709 0-1.825.007-1.798.11ZM81.08 25.62h3.522V14.017H81.08zm10.034-10.954c-.192.357-1.494 2.818-2.893 5.469a3207 3207 0 0 1-2.724 5.153l-.18.334 3.672-.033.832-1.617 4.163.031.382 1.617h1.81c1.23 0 1.81-.021 1.81-.067 0-.037-.62-2.631-1.377-5.765a996 996 0 0 1-1.376-5.736c0-.02-.848-.037-1.885-.037h-1.884l-.35.65Zm7.577 10.954h3.521l.033-5.844 4.291 5.84 3.106.004V14.017h-3.521l-.034 5.485-3.906-5.483-3.49-.002zm11.655-8.56h3.329l.033 8.592.974.018c.953.017.976.014 1.066-.127.05-.08.39-.701.755-1.381l.663-1.237.064-5.834 3.019-.034.78-1.479c.429-.813.78-1.497.78-1.52 0-.024-2.579-.042-5.732-.042h-5.731zm-17.349 2.858c.162.66.28 1.214.261 1.231-.017.018-.46.032-.985.032h-.954l.66-1.262c.363-.695.674-1.249.692-1.232s.164.571.326 1.23Zm-49.515 8.634c-.076.15-1.446 2.745-3.044 5.77-1.597 3.025-2.905 5.514-2.905 5.533 0 .018.814.033 1.81.033l1.808-.001.873-1.647h4.144l.137.587c.075.322.165.693.2.824l.063.238h3.647l-.035-.143c-.02-.078-.65-2.682-1.4-5.787l-1.362-5.643-3.797-.034zm7.435 11.337h3.459v-3.361h1.61l1.653 3.36h3.664l-.477-.903c-.263-.497-.744-1.41-1.069-2.03l-.59-1.126.484-.448c.869-.803 1.237-1.79 1.177-3.158-.08-1.864-1.039-3.155-2.77-3.734l-.513-.172-6.628-.04zm10.439-8.561h3.33v8.56h2.039l1.482-2.821.001-5.74h3.042l.784-1.484c.432-.817.785-1.501.785-1.522 0-.02-2.58-.037-5.732-.037h-5.731zm-4.62.192c.366.204.521.507.521 1.013 0 .535-.161.83-.556 1.02-.278.133-.396.147-1.3.15l-.993.003-.018-1.108c-.01-.609-.002-1.147.017-1.196.028-.073.219-.085 1.042-.064.925.024 1.03.039 1.287.182ZM45.43 35.19l.04.197h-.96c-.527 0-.958-.017-.958-.037s.097-.213.216-.428c.118-.215.412-.762.652-1.215l.437-.825.266 1.055c.147.58.285 1.144.307 1.253Z",
        clipRule: "evenodd",
        mask: "url(#z)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#A)",
        strokeLinejoin: "round",
        d: "M29.21 14.22c-.128.13-.684 1.1-1.347 2.351l-1.13 2.13-.759.499H18l.033 6.437 4.437.033.341.443-4.81 9.108v4.652h4.777l.25-.253c.17-.172.601-.916 1.35-2.33 1.07-2.018 1.111-2.085 1.44-2.316l.338-.237h8.047v-6.469h-4.387l-.176-.218c-.096-.12-.176-.252-.176-.293s1.067-2.091 2.37-4.558l2.37-4.484V14h-4.779z",
        clipRule: "evenodd",
        mask: "url(#z)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#B)",
        strokeLinejoin: "round",
        d: "m75.756 37.354 3.888-3.33q.648-.54.972-.918.342-.378.468-.666a1.6 1.6 0 0 0 .126-.63q0-.468-.45-.81-.45-.36-1.404-.36-.882 0-1.674.216a8.4 8.4 0 0 0-1.692.648l-.18-2.772a8.8 8.8 0 0 1 1.98-.774 8.4 8.4 0 0 1 2.214-.288q2.196 0 3.42 1.044 1.242 1.044 1.242 2.772 0 1.188-.702 2.178-.684.972-1.962 2.052l-1.656 1.404h4.572V40h-9.162z",
        mask: "url(#z)"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "url(#C)",
        strokeLinejoin: "round",
        d: "M91.653 40v-2.052h-5.796v-2.412l3.69-7.686h3.006v1.08l-2.988 6.228h2.088v-2.124h3.15v2.124h1.422v2.79h-1.422V40z",
        mask: "url(#z)"
    })), /*#__PURE__*/ React.createElement("circle", {
        cx: 18,
        cy: 19,
        r: 15,
        fill: "url(#D)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 34.5,
        cy: 34.5,
        r: 7.5,
        fill: "url(#E)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 92.5,
        cy: 28.5,
        r: 6.5,
        fill: "url(#F)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 84.5,
        cy: 14.5,
        r: 7.5,
        fill: "url(#G)",
        style: {
            mixBlendMode: 'color-dodge'
        }
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "c",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "d",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "e",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "f",
        x1: 104,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.162,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.509,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.723,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.78,
        stopColor: "#6A4800"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.819,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "g",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "i",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "j",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "k",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "l",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "m",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "n",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "o",
        x1: 104.711,
        x2: 104.711,
        y1: 40,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "p",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "r",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "s",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "t",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "u",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "v",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "w",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "x",
        x1: 104.711,
        x2: 104.5,
        y1: 40,
        y2: 18.5,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.01,
        stopColor: "#FFF0DA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.042,
        stopColor: "#94641E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.828,
        stopColor: "#FFF2DB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.938,
        stopColor: "#EAC885"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.979,
        stopColor: "#FBF5D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#BD9A4B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#ECD8A3"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "y",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "A",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "B",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "C",
        x1: 69.904,
        x2: 69.904,
        y1: 14,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FCF6D1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.104,
        stopColor: "#BD9457"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.25,
        stopColor: "#E3CA89"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.698,
        stopColor: "#FEE8C8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.854,
        stopColor: "#4D3A1A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FCF0D1"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 27 -66 0 66 27)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#775014"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "D",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 15 -15 0 18 19)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "E",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(90 0 34.5)scale(7.5)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "F",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(90 32 60.5)scale(6.5)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "G",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(90 35 49.5)scale(7.5)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "b",
        width: 107.809,
        height: 31,
        x: 16,
        y: 13,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: 2
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3_504"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_3_504",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        result: "effect2_foregroundBlur_3_504",
        stdDeviation: 0.5
    }))))));
};
Logo.displayName = 'Logo';
export default Logo;

//# sourceMappingURL=Logo.dabirthday_24.dark.js.map